import { CommonModule } from '@angular/common';
import { AfterContentChecked, Component, EventEmitter, forwardRef, Input, Output, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { UserDashboard } from '../../app.models';

@Component({
  selector: 'course-dropdown',
  templateUrl: './course-dropdown.component.html',
  styleUrls: ['./course-dropdown.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CourseDropdownComponent),
      multi: true,
    },
  ],
  standalone: true,
  imports: [CommonModule, FormsModule, NgbDropdownModule],
})
export class CourseDropdownComponent implements ControlValueAccessor, AfterContentChecked {
  @Input() userDashboard = new UserDashboard();
  @Input() defaultText = 'Select Item';
  @Input() preSelectedSubject = '';
  @Output() courseOutput = new EventEmitter<string>();

  public value: string;
  public isDisabled: boolean;

  public onChange;
  currentSelection: string = '';

  onTouched = () => {};

  constructor() {}

  ngAfterContentChecked() {
    if (this.preSelectedSubject !== '' && this.currentSelection === '') {
      this.selectItem(this.preSelectedSubject);
    }
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  writeValue(value: string): void {
    this.value = value;
  }

  selectItem(courseName): void {
    this.onChange(courseName);
    this.value = courseName;
    this.currentSelection = courseName;
    this.courseOutput.emit(courseName);
  }
}
